import { render, staticRenderFns } from "./FeedbackComm.vue?vue&type=template&id=60a66056&"
import script from "./FeedbackComm.vue?vue&type=script&lang=js&"
export * from "./FeedbackComm.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackComm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports